import { inject, injectable } from "@launchtray/tsyringe-async";
import { SceneManager } from "../../../../scene/SceneManager";
import { ModuleFlowExecutor } from "../../../composition/module/ModuleFlowExecutor";
import { LoginModule } from "./LoginModule";
import { MainLoginPopupScene } from "./mainloginpopup/MainLoginPopupScene";
import { TopPanel } from "../../game/components/toppanel/TopPanel";
import { ILogger } from "../../../logger/ILogger";

@injectable()
export class LoginModuleFlowExecutor extends ModuleFlowExecutor<LoginModule, void> {
    private readonly sceneManager: SceneManager;
    private readonly topPanel: TopPanel;
    private readonly logger: ILogger;

    private topPanelOnNotificationAfterExecute: boolean;

    public constructor(
        sceneManager: SceneManager,
        topPanel: TopPanel,
        @inject("ILogger") logger: ILogger
    ) {
        super();
        this.sceneManager = sceneManager;
        this.topPanel = topPanel;
        this.logger = logger;
        this.topPanelOnNotificationAfterExecute = false;
        this.topPanel.onLayerChanged.add(this.onTopPanelLayerChanged, this);
    }

    public async execute(module: LoginModule): Promise<void> {
        try {
            this.topPanelOnNotificationAfterExecute = this.topPanel.onNotificationLayer;
            if (this.topPanelOnNotificationAfterExecute) {
                this.topPanel.bringToOriginParent(true);
            }
            const mainLoginScene = await module.resolve(MainLoginPopupScene);
            await this.sceneManager.showViewableAsync(mainLoginScene);
            this.topPanel.onLayerChanged.remove(this.onTopPanelLayerChanged, this);
            if (this.topPanelOnNotificationAfterExecute) {
                this.topPanel.bringToFront();
            }
            else {
                this.topPanel.bringToOriginParent();
            }
        }
        catch (e: unknown) {
            this.logger.error(`Exception on executing LoginModule: `, e);
        }
        finally {
            this.topPanel.onLayerChanged.remove(this.onTopPanelLayerChanged, this);
        }
    }

    private onTopPanelLayerChanged(): void {
        this.topPanelOnNotificationAfterExecute = this.topPanel.onNotificationLayer;
        if (this.topPanel.onNotificationLayer) {
            this.topPanel.bringToOriginParent(true);
        }
    }
}